import { State } from "../types";

// Static color mapping for each Australian state/territory
// https://en.wikipedia.org/wiki/Australian_state_and_territory_colours
export const STATE_COLORS: Record<State, string> = {
  ACT: "#003da5",
  NSW: "#9bcbeb",
  NT: "#c25e03", 
  QLD: "#73182c",
  SA: "#d50032",
  TAS: "#006747",
  VIC: "#003c71",
  WA: "#ffd100",
};

// Text color (black/white) for each state based on background contrast
export const STATE_TEXT_COLORS: Record<State, string> = {
  ACT: "#fff",
  NSW: "#000",
  NT: "#fff", 
  QLD: "#fff",
  SA: "#fff",
  TAS: "#fff",
  VIC: "#fff",
  WA: "#000",
};

export const FEDERAL_COLOR = "#9313b3ff";
export const FEDERAL_TEXT_COLOR = "#fff";

export const MULTI_STATE_COLOR = "#9313b3ff"; // Same as federal for multi-state holidays
export const MULTI_STATE_TEXT_COLOR = "#fff";

// Get color for a specific state or states
export const getStateColor = (states?: State | State[]): string => {
  // Federal holidays (empty array or undefined)
  if (!states || (Array.isArray(states) && states.length === 0)) {
    return FEDERAL_COLOR;
  }

  // Single state (string)
  if (typeof states === "string") {
    return STATE_COLORS[states];
  }

  // Multiple states - return first state's color
  if (Array.isArray(states) && states.length > 0) {
    return STATE_COLORS[states[0]];
  }

  return "#95a5a6"; // UNKNOWN
};

// Get text color for a specific state or states
export const getStateTextColor = (states?: State | State[]): string => {
  // Federal holidays (empty array or undefined)
  if (!states || (Array.isArray(states) && states.length === 0)) {
    return FEDERAL_TEXT_COLOR;
  }

  // Multiple states - use multi-state color
  if (Array.isArray(states) && states.length > 1) {
    return MULTI_STATE_TEXT_COLOR;
  }

  // Single state (string)
  if (typeof states === "string") {
    return STATE_TEXT_COLORS[states];
  }

  // Single state in array
  if (Array.isArray(states) && states.length === 1) {
    return STATE_TEXT_COLORS[states[0]];
  }

  return "#000"; // UNKNOWN
};

// Get background color for a specific state or states
export const getColorForPill = (states?: State | State[]): string => {
  // Federal holidays (empty array or undefined)
  if (!states || (Array.isArray(states) && states.length === 0)) {
    return FEDERAL_COLOR;
  }

  // Multiple states - use multi-state color
  if (Array.isArray(states) && states.length > 1) {
    return MULTI_STATE_COLOR;
  }

  // Single state (string)
  if (typeof states === "string") {
    return STATE_COLORS[states];
  }

  // Single state in array
  if (Array.isArray(states) && states.length === 1) {
    return STATE_COLORS[states[0]];
  }

  return "#95a5a6"; // UNKNOWN
};

// Get text color for pill (handles multi-state separately)
export const getTextColorForPill = (states?: State | State[]): string => {
  // Federal holidays (empty array or undefined)
  if (!states || (Array.isArray(states) && states.length === 0)) {
    return FEDERAL_TEXT_COLOR;
  }

  // Multiple states - use multi-state color
  if (Array.isArray(states) && states.length > 1) {
    return MULTI_STATE_TEXT_COLOR;
  }

  // Single state (string)
  if (typeof states === "string") {
    return STATE_TEXT_COLORS[states];
  }

  // Single state in array
  if (Array.isArray(states) && states.length === 1) {
    return STATE_TEXT_COLORS[states[0]];
  }

  return "#000"; // UNKNOWN
};
